<template>
	<div class="goodListBox">
		<div class="goodListHead">
			<div class="headLeft"  @click="$router.go(-1)" >
				<img src="../../assets/img/icon/Arrowleft000.png" alt="">
			</div>
			<div class="centerSearch"><van-search v-model="value" shape="round" placeholder="搜索商品" />
			</div>
			<div class="headRight" @click="togglePermu">
				<img v-if=" permutation == 'rect' " src="../../assets/img/icon/rectShow.png" alt="">
				<img v-if=" permutation ==  'vertical' " src="../../assets/img/icon/verticalShow.png" alt="">
			</div>
		</div>
		<div class="listTools">
			<div> <span>综合</span> </div>
			<div> <span>销量</span> </div>
			<div> <span>价格</span> <img src="../../assets/img/icon/higher.png" alt=""> </div>
			<div @click="showFilters()"> <span>筛选</span> <img src="../../assets/img/icon/filters.png" alt=""> </div>
		</div>
		<div v-if=" permutation == 'vertical' ">
			<listOfItems>
				<img src="../../assets/img/icon/dayLottery.png" alt="">
			</listOfItems>
			<listOfItems>
				<img src="../../assets/img/icon/dayLottery.png" alt="">
			</listOfItems>
		</div>
		<div v-if=" permutation == 'rect' ">
			<verticalItemList></verticalItemList>
			<verticalItemList></verticalItemList>
		</div>
		<van-action-sheet v-model="showFilter">
			<div class="filterContent">
				<div class="topIcon"></div>
				<div class="priceRange">
					<h4>价格区间</h4>
					<van-form>
						<van-field v-model="lowPrice" name="最低价" placeholder="最低价" />
						<span>-</span>
						<van-field v-model="highPrice" name="最高价" placeholder="最高价" />
					</van-form>
				</div>
				<div class="brand">
					<h4>品牌</h4>
					<div class="brandList">
						<span class="active">稻草人</span>
						<span>老人头</span>
						<span>七匹狼</span>
						<span>琢木鸟</span>
						<span>时尚潮流</span>
						<span>海澜之家</span>
					</div>
				</div>
				<div class="dayLuckDraw">
					<h4>天天抽奖</h4>
					<div class="LuckDraw">
						<span class="active">抽奖</span>
					</div>
				</div>
				<div class="filterBtn" >
					<button class="resetBtn" >重置</button>
					<button class="saveBtn" >确定</button>
				</div>
			</div>
		</van-action-sheet>
	</div>

</template>

<script>
	import listOfItems from '../../components/listOfItems.vue';
	import verticalItemList from '../../components/verticalItemList.vue';
	export default {
		name: 'dayLotteryList',
		data() {
			return {
				value: '',
				permutation: "vertical",
				showFilter: false,
				lowPrice: "",
				highPrice: '',
				result: []

			}
		},
		components: {
			listOfItems,
			verticalItemList
		},
		methods: {
			togglePermu() {
				if (this.permutation == 'vertical') {
					this.permutation = 'rect'
				} else {
					this.permutation = 'vertical'
				}
			},
			showFilters() {
				this.showFilter = true
			}
		}
	}
</script>
<style scoped lang='less'>
	.goodListBox {
		.goodListHead {
			display: flex;
			justify-content: space-between;
			background-color: #fff;
			position: relative;
			padding: 0 30px;

			.headLeft {
				img {
					width: 20px;
					height: 36px;
					position: absolute;
					top: 50%;
					transform: translateY(-50%);
				}
			}

			.centerSearch {
				width: 90%;
				height: 110px;
			}

			.headRight {
				img {
					width: 34px;
					height: 30px;
					position: absolute;
					top: 50%;
					transform: translateY(-50%);
					right: 26px;
				}
			}
		}

		.listTools {
			display: flex;
			justify-content: space-between;
			background-color: #fff;
			padding: 20px 0;

			div {
				width: 25%;
				text-align: center;

				span {
					font-size: 28px;
					color: #333333;
				}

				img {
					display: inline-block;
					width: 16px;
					height: 20px;
				}
			}
		}

		/deep/ .Commission {
			img {
				width: 66px;
				height: 28px;
				float: right;
			}
		}

		.filterContent {
			padding: 10px 0px;

			.topIcon {
				width: 60px;
				height: 12px;
				background-color: #B9B9B9;
				border-radius: 8px;
				margin: 0 auto;
			}

			.priceRange {
				text-align: center;
				padding: 0 20px;
				border-bottom: solid 4px #F2F2F2;

				h4 {
					text-align: left;
					margin: 25px 0;
				}

				/deep/ .van-cell {
					width: 40%;
					background: rgba(242, 242, 242, 1);
					border-radius: 30px;
					padding: 5px;
					display: inline-block;
					text-align: center;

					input {
						text-align: center;
					}
				}

				span {
					display: inline-block;
					margin-bottom: 30px;
					margin: 0 20px;
					height: 80px;
					vertical-align: middle;
				}
			}

			.brand {
				padding: 20px;
				background-color: #fff;

				h4 {
					color: #040404;
					font-size: 24px;
					margin-bottom: 26px;
				}

				.brandList {
					span {
						display: inline-block;
						background: rgba(242, 242, 242, 1);
						border-radius: 27px;
						width: 167px;
						height: 54px;
						text-align: center;
						line-height: 54px;
						margin-right: 14px;
						margin-bottom: 30px;
					}

					span:nth-child(4n) {
						margin-right: 0;
					}

					span.active {
						border: solid 2px #F33925;
						color: #FE5E15;
					}
				}
			}
			.dayLuckDraw {
				padding: 20px;
				background-color: #fff;
				border-bottom: solid 4px #F2F2F2;
				h4 {
					color: #040404;
					font-size: 24px;
					margin-bottom: 26px;
				}
				.LuckDraw{
					span {
						display: inline-block;
						background: rgba(242, 242, 242, 1);
						border-radius: 27px;
						width: 167px;
						height: 54px;
						text-align: center;
						line-height: 54px;
						margin-right: 14px;
						margin-bottom: 30px;
					}
					span.active {
						border: solid 2px #F33925;
						color: #FE5E15;
					}
				}
			}
			.filterBtn{
				padding: 40px 68px;
				.resetBtn{
					width:294px;
					height:67px;
					background:rgba(255,255,255,1);
					border-radius:34px;
					border:1px solid rgba(148,148,148,1);
					color: #343434;
					font-size: 24px;
					margin-right: 26px;
				}
				.saveBtn{
					width:294px;
					height:67px;
					background: linear-gradient(to right,#F2170C,#F24C0B);
					color: #fff;
					font-size: 24px;
					border-radius:34px;
					
				}
			}
		}
	}
</style>
